import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UtilService} from "../../services/util.service";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {EPDSFile} from "../../models/file-upload";

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.scss',
    standalone: false
})
export class FileUploadComponent {
  @ViewChild(MatTable) table!: MatTable<EPDSFile>;
  @ViewChild('fileUpload', { static: false }) fileUpload!: ElementRef;
  @ViewChild('associatedFileUpload', { static: false }) associatedFileUpload!: ElementRef;

  @Input() fileUploadInProgress = false;
  @Input() wrongFileTypeMessage!: string;
  @Input() requiredFileType!: string[];
  @Input() showAssociatedDocuments = true;
  @Input() primaryUploadText = 'Upload Document';
  @Input() associatedUploadText = 'Upload Associated Document';
  @Input() associatedDocsOnly = false;

  @Output() primaryEPDSFileListOutput = new EventEmitter<EPDSFile[]>();
  @Output() associateEPDSFileListOutput = new EventEmitter<EPDSFile[]>();
  @Output() attachAssociatedDocOutput = new EventEmitter<boolean>();

  hideCancelButton = false;
  attachAssociatedDoc!: boolean;
  primaryDataSource = new MatTableDataSource<EPDSFile>();
  associateDataSource = new MatTableDataSource<EPDSFile>();

  displayedColumns: string[] = ['index', 'name', 'size', 'progress', 'actions'];
  errors!: string;
  primaryDocumentAdded = false;

  constructor(private readonly util: UtilService) {
  }

  onFileSelected(event: any, typeOfFile: string) {
    const listOfFiles: FileList = event.target.files;
    const EPDSFileListInput: EPDSFile[] = (typeOfFile === 'P') ? this.primaryDataSource.data : this.associateDataSource.data;

    for (let tempFile of Array.from(listOfFiles)) {
      const tempFileType = tempFile.name.split('.').pop();

      if (tempFileType && this.requiredFileType.includes(tempFileType)) {
        const tempEPDSFile: EPDSFile = {
          name: tempFile.name, size: tempFile.size, progress: 0, error: false, isFileComplete: false, typeOfFile, file: tempFile
        };

        if (typeOfFile === 'P') {
          this.primaryDocumentAdded = true;
        }

        EPDSFileListInput.push(tempEPDSFile);
      } else {
        this.util.displayDialogMessage('Error', this.wrongFileTypeMessage,
          {
            cancelBtn: false,
            confirmText: 'OK',
            cancelText : 'Cancel',
            confirmButtonColor: 'primary',
            cancelButtonColor: 'warn',
            getResponse: false
          })
      }
    }

    if (typeOfFile === 'P') {
      this.primaryDataSource.data = EPDSFileListInput;
      this.primaryEPDSFileListOutput.emit(this.primaryDataSource.data);
    } else {
      this.associateDataSource.data = EPDSFileListInput;
      this.associateEPDSFileListOutput.emit(this.associateDataSource.data);
    }
  }

  fileCancel(typeOfFile: string, eraseAll?: boolean, i?: number) {
    if (typeOfFile === 'P') {
      this.primaryDataSource.data = [];
      this.primaryDocumentAdded = false;

      this.fileUpload.nativeElement.value = '';
      this.primaryEPDSFileListOutput.emit(this.primaryDataSource.data);
    } else {
      if (eraseAll) {
        this.associateDataSource.data = [];
      } else if (i !== undefined){
        this.associateDataSource.data.splice(i, 1);
        this.associateDataSource.data = [...this.associateDataSource.data];
      }

      if (this.associatedFileUpload) {
        this.associatedFileUpload.nativeElement.value = '';
      }

      this.associateEPDSFileListOutput.emit(this.associateDataSource.data);
    }
  }

  onAttachAssociatedDocChange() {
    this.attachAssociatedDocOutput.emit(this.attachAssociatedDoc)

    if (!this.attachAssociatedDoc) {
      this.fileCancel('A', true);
    }
  }

}
